import React from 'react';
import { Paper, Grid, Typography, FormGroup, FormControlLabel, Checkbox } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import DetailColumn from './DetailColumn';
import RoomDetail from './RoomDetail';
import currencyFormatter from 'currency-formatter';
import { translate } from 'react-i18next';
import moment from 'moment';

const styles = theme => ({
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: 'var(--error-color)',
        textAlign: 'right'
    },
    paperFrame: {
        margin: '15px 0px'
    }
});

class ReservationDetailsRender extends React.Component {
    constructor(props) {
        super(props);
        props = { displayprice: true };
        this.state = {
            cancellationInsurance: props.cancellationInsurance
        };
    }

    getDataFromValuation = (B2bVerPVP) => {
        const reservation = this.props.reservation;
        let dateIn = reservation.checkInDate;
        //lunes, 4 de Junio de 2018
        let dateOut = moment(dateIn, 'DD/MM/YYYY')
            .add(reservation.nights, 'days')
            .format(this.props.t('DATE_FORMAT.LONG'));

        dateIn = moment(dateIn, 'DD/MM/YYYY').format(this.props.t('DATE_FORMAT.LONG'));

        let adults =
            reservation && reservation.rooms ? reservation.rooms.reduce((acc, r) => acc + Number(r.adults), 0) : 0;

        let kids =
            reservation && reservation.rooms
                ? reservation.rooms.reduce((acc, r) => acc + Number(r.kids.length), 0)
                : 0;

        let price = B2bVerPVP ? reservation.pvpPrice : reservation.salePrice;

        return {
            dateIn,
            dateOut,
            adults,
            kids,
            price
        };

    }

    responseFromValuation = reservation => {
        return !(reservation.hasOwnProperty('__frommethod'));
    }

    onCheck = (event, value) => {
        this.props.onCheck(value);
    };

    render() {
        let dateIn = '';
        let dateOut = '';
        let adults = 0;
        let kids = 0;
        let price = 0;
        const { reservation, classes, t, cancellationInsurance, iframeToken } = this.props;
        const user = JSON.parse(localStorage.getItem('user'));
        const B2bVerPVP = user.authorities.includes('B2bVerPVP');
        const confirmView = reservation && !reservation.state;
        if (reservation) {

            if (this.responseFromValuation(reservation)) {
                const dataAux = this.getDataFromValuation(reservation, B2bVerPVP);
                dateIn = dataAux.dateIn;
                dateOut = dataAux.dateOut;
                adults = dataAux.adults;
                kids = dataAux.kids;
                price = dataAux.price;
            }
            else {
                //lunes, 4 de Junio de 2018
                dateIn = moment(this.props.reservation.checkIn, 'DD/MM/YYYY').format(t('DATE_FORMAT.LONG'));
                dateOut = moment(this.props.reservation.checkOut, 'DD/MM/YYYY').format(t('DATE_FORMAT.LONG'));

                adults = reservation.totalAdults;
                kids = reservation.totalKids;
                price = B2bVerPVP ? reservation.pvp : reservation.price;
            }
        }

        return (
            <Paper className={classes.paperFrame}>

                <Typography className={classes.bookingTitle}>
                    {t('BOOKING_DETAIL.BOOKING_DETAIL')}
                </Typography>

                <Grid container spacing={40} xs={12} style={{ padding: 24 }}>
                    <DetailColumn {...[t('COMMON.CHECK_IN'), dateIn]} />
                    <DetailColumn {...[t('COMMON.CHECK_OUT'), dateOut]} />
                    <DetailColumn {...[t('COMMON.NIGHTS'), this.props.reservation ? this.props.reservation.nights : '']} />
                    {this.props.reservation && this.props.reservation.rooms && this.props.reservation.rooms.length > 0 ? (
                        kids > 0 ? (
                            <DetailColumn {...[t('BOOKING_DETAIL.OCCUPATION'), adults + ' ' + t('COMMON.ADULTS') + ', ' + kids + ' ' + t('COMMON.CHILDREN')]} />
                        ) : (
                                <DetailColumn {...[t('BOOKING_DETAIL.OCCUPATION'), adults + ' ' + t('COMMON.ADULTS')]} />
                            )
                    ) : (
                            <DetailColumn {...[t('BOOKING_DETAIL.OCCUPATION'), t('BOOKING_DETAIL.OCCUPATION_DETAIL_NOT_AVAILABLE')]} />
                        )}
                    <Grid item xs={this.props.displayprice === true ? 2 : 4} direction={'column'} className="cmsDetailsRooms">
                        <Typography style={{ fontWeight: 700, fontSize: '16px' }}>{t('BOOKING_DETAIL.SELECTION')}</Typography>
                        {this.props.reservation && this.props.reservation.rooms
                            ? this.props.reservation.rooms.map((r, index) => <RoomDetail room={r} key={index} {...r} />)
                            : ''}
                    </Grid>
                    {cancellationInsurance && cancellationInsurance.active === 'SI' && confirmView && !iframeToken &&
                        <Grid>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            onChange={this.onCheck}
                                            disabled={iframeToken}
                                            value={reservation.cancellationInsuranceAcepted}
                                        />
                                    }
                                    label={
                                        <span style={{ fontWeight: 300 }}>
                                            {t('BOOKINGS.LABEL_CANCELLATION_INSURANCE')}
                                            <b>{t('BOOKINGS.CANCELLATION_INSURANCE')}</b>
                                            <a href="../../../assets/Clausulas SEGURO ANULACION_ESP.pdf" target='_blank'>{t('BOOKINGS.SHOW_CONDITIONS')}</a>
                                        </span>}
                                />
                            </FormGroup>
                        </Grid>
                    }
                    {this.props.displayprice === true && (!cancellationInsurance || (cancellationInsurance && cancellationInsurance.active === 'NO')) ? (
                        <Grid item xs={2} alignItems="flex-start">
                            <Typography style={{ textAlign: 'right', fontWeight: 700, fontSize: '16px' }}>
                                {this.props.currentprincelabel ? t('BOOKING_DETAIL.ACTUAL_PRICE') : t('BOOKING_DETAIL.PRICE')}
                            </Typography>
                            <Typography className={classes.price}>
                                {this.props.reservation
                                    ? currencyFormatter.format(price, { code: 'EUR' })
                                    : '0€'}
                            </Typography>
                        </Grid>
                    ) : (
                            ''
                        )}
                </Grid>

                {
                    reservation && reservation.cancellationInsuranceAcepted && iframeToken &&
                    <Grid item container xs={12} style={{ margin: 0 }}>
                        <Typography>
                            {
                                t('BOOKINGS.CANCELLATION_INSURANCE_INCLUDED')
                            }
                        </Typography>
                    </Grid>
                }
            </Paper>
        );

    }
}
export default translate('translations')(withStyles(styles)(ReservationDetailsRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationDetailsRender.js